module.exports = __webpack_public_path__ + "static/media/alternator-mr-card-back.9df2d942.jpeg";